import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Heading } from 'components/Heading'
import { Stack } from 'components/Stack'
import { CustomLayersCard } from './components/CustomLayersCard'
import styles from './Datasets.module.scss'

export const Datasets: FC = (props) => {
  const { t } = useTranslation()

  return (
    <div className={styles.datasets}>
      <Stack space="small">
        <Heading>{t('datasets.title')}</Heading>
        <Stack space="medium">
          <CustomLayersCard />
        </Stack>
      </Stack>
    </div>
  )
}

Datasets.displayName = 'Datasets'
